import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2 } from "lucide-react";
import PartyAutocomplete from "@/components/shared/PartyAutocomplete";

export function VehicleEntryForm({ form, setField, vehicleTypes, parties, onSelectOrOther, setOtherField }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Vehicle No. *</Label>
        <Input value={form.vehicle_no || ""} onChange={e => setField("vehicle_no", e.target.value)} className="h-11" data-testid="field-vehicle-no" />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Vehicle Type</Label>
        <Select value={form.vehicle_type || ""} onValueChange={v => onSelectOrOther("vehicle_type", v, "vehicle_types")}>
          <SelectTrigger className="h-11"><SelectValue placeholder="Select type" /></SelectTrigger>
          <SelectContent>
            {vehicleTypes.map(p => <SelectItem key={p.id} value={p.name}>{p.name}</SelectItem>)}
            <SelectItem value="__other__" className="text-amber-600 font-semibold">Other (not in list)</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Driver Name *</Label>
        <Input value={form.driver_name || ""} onChange={e => setField("driver_name", e.target.value)} className="h-11" />
      </div>
      <div className="col-span-2 space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Parties / Companies *</Label>
        <div className="space-y-2">
          {(form.parties_list || [""]).map((party, i) => (
            <div key={`party-slot-${i}`} className="flex gap-2 items-start">
              <div className="flex-1">
                <PartyAutocomplete
                  value={party || ""}
                  onChange={(v) => {
                    const list = [...(form.parties_list || [""])];
                    list[i] = v;
                    setField("parties_list", list);
                  }}
                  label=""
                  masterType="parties"
                  testId={`vehicle-party-autocomplete-${i}`}
                  placeholder={`Party / Company ${i + 1}`}
                />
              </div>
              {(form.parties_list || [""]).length > 1 && (
                <Button variant="ghost" size="sm" className="h-11 w-9 p-0 text-red-500" onClick={() => {
                  const list = [...(form.parties_list || [])].filter((_, j) => j !== i);
                  setField("parties_list", list);
                }}>
                  <Trash2 size={14} />
                </Button>
              )}
            </div>
          ))}
          <Button variant="outline" size="sm" className="h-8 text-xs gap-1" data-testid="add-party-btn" onClick={() => {
            setField("parties_list", [...(form.parties_list || [""]), ""]);
          }}>
            <Plus size={14} /> Add Another Party
          </Button>
        </div>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wider font-bold text-gray-500">Purpose</Label>
        <Input value={form.purpose || ""} onChange={e => setField("purpose", e.target.value)} className="h-11" />
      </div>
      <div className="space-y-1.5 flex items-end">
        <label className="flex items-center gap-2 h-11">
          <input type="checkbox" checked={form.ctpat_seal_check || false} onChange={e => setField("ctpat_seal_check", e.target.checked)} className="w-5 h-5 rounded" />
          <span className="text-sm">CTPAT Seal Intact</span>
        </label>
      </div>
    </div>
  );
}
